import { FeatureToggleClientService } from 'feature-toggle-client';
const blipSupportIsEnabled = 'blip-support-is-cluster-enabled';
export class BlipSupportFeatures {
    static async isBlipSupportEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipSupportIsEnabled);
    }
}
